import { SDK_VERSION, init as init$1, addGlobalEventProcessor } from '@sentry/browser';
import { getDomElement } from '@sentry/utils';

/**
 * Inits the Svelte SDK
 */
function init(options) {
  const opts = {
    _metadata: {} ,
    ...options,
  };

  opts._metadata.sdk = opts._metadata.sdk || {
    name: 'sentry.javascript.svelte',
    packages: [
      {
        name: 'npm:@sentry/svelte',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init$1(opts);

  detectAndReportSvelteKit();
}

/**
 * Adds a global event processor to detect if the SDK is initialized in a SvelteKit frontend,
 * in which case we add SvelteKit an event.modules entry to outgoing events.
 * SvelteKit detection is performed only once, when the event processor is called for the
 * first time. We cannot perform this check upfront (directly when init is called) because
 * at this time, the HTML element might not yet be accessible.
 */
function detectAndReportSvelteKit() {
  let detectedSvelteKit = undefined;

  const svelteKitProcessor = event => {
    if (detectedSvelteKit === undefined) {
      detectedSvelteKit = isSvelteKitApp();
    }
    if (detectedSvelteKit) {
      event.modules = {
        svelteKit: 'latest',
        ...event.modules,
      };
    }
    return event;
  };
  svelteKitProcessor.id = 'svelteKitProcessor';

  addGlobalEventProcessor(svelteKitProcessor);
}

/**
 * To actually detect a SvelteKit frontend, we search the DOM for a special
 * div that's inserted by SvelteKit when the page is rendered. It's identifyed
 * by its id, 'svelte-announcer', and it's used to improve page accessibility.
 * This div is not present when only using Svelte without SvelteKit.
 *
 * @see https://github.com/sveltejs/kit/issues/307 for more information
 */
function isSvelteKitApp() {
  return getDomElement('div#svelte-announcer') !== null;
}

export { detectAndReportSvelteKit, init, isSvelteKitApp };
//# sourceMappingURL=sdk.js.map
